import * as z from 'zod';

import axios from '../localAxios';

const StudentTimerDataSchema = z.object({
  userUuid: z.string(),
  state: z.enum(['running', 'paused', 'expired', 'finished']),
  expiresAt: z.string().nullable().optional(),
  remainingSeconds: z.number().nullable().optional(),
  finishedAt: z.string().nullable().optional(),
  createdAt: z.string().optional(),
  timerDurationSeconds: z.number(),
});

const ActivityTimersResponseSchema = z.object({
  activityInstanceId: z.number(),
  serverTime: z.string(),
  timers: z.array(StudentTimerDataSchema),
});

export type StudentTimerData = z.infer<typeof StudentTimerDataSchema>;
export type ActivityTimersResponse = z.infer<
  typeof ActivityTimersResponseSchema
>;

export type ActivityTimersResult = {
  data: ActivityTimersResponse;
  networkLatencyMs: number;
};

export async function getActivityTimers(
  activityInstanceId: number
): Promise<ActivityTimersResult> {
  const t1 = Date.now();
  const response = await axios.get(`/activities/${activityInstanceId}/timers`);
  const t4 = Date.now();

  const { data, error } = ActivityTimersResponseSchema.safeParse(response.data);

  if (error) {
    throw new Error(error.message);
  }

  return {
    data,
    networkLatencyMs: t4 - t1,
  };
}
